export const cognitoConfig = {
  clientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
  domain: import.meta.env.VITE_COGNITO_DOMAIN,
  scopes: "aws.cognito.signin.user.admin email openid profile",
};

export const getCognitoLoginUrl = (schemaName?: string) => {
  if (!schemaName) return "#";
  return `https://${schemaName}.app.getsmarteye.mobi`;
};
